// extracted by mini-css-extract-plugin
export default {"grid":"components_grid__cVfub","title":"components_title__M8SUU","editButton":"components_editButton__pvkQk","imageBackground":"components_imageBackground__YumxW"};